import './_sass/main.sass'

import $ from 'jquery'
import Vue from 'vue'
import VueRouter from 'vue-router'
import transition from './_app/transition.js'

Vue.use(VueRouter);

var App = Vue.extend()

var router = new VueRouter()

router.map({
  '/': {
    component: require('./_vue/app-shell.vue'),
    subRoutes: {
      '/': {
        component: require('./_vue/Home.vue')
      },
      '/targets': {
        component: require('./_vue/Nav.vue')
      },
      '/content-creators': {
        component: require('./_vue/pages/content-creators.vue')
      },
      '/content-owners': {
        component: require('./_vue/pages/content-owners.vue')
      },
      '/content-distributors': {
        component: require('./_vue/pages/content-distributors.vue')
      },
      '/ce-manufacturers': {
        component: require('./_vue/pages/ce-manufacturers.vue')
      },
      '/ce-distributors': {
        component: require('./_vue/pages/ce-distributors.vue')
      },
      '/consumers': {
        component: require('./_vue/pages/consumers.vue')
      }
    }
  }
})

router.start(App, 'body')


/** WEBPACK FOOTER **
 ** ./public/_src/index.js
 **/